module.exports = __webpack_public_path__ + "static/media/info.96eb75b4.svg";